import React from 'react'
import LbAnalytics from '../../Components/LeadBridge/LbAnalytics'
import LbCTA from '../../Components/LeadBridge/LbCTA'
import LbFAQs from '../../Components/LeadBridge/LbFAQs'
import LbHero from '../../Components/LeadBridge/LbHero'
import LbHowItWorks from '../../Components/LeadBridge/LbHowItWorks'
import LbPricing from '../../Components/LeadBridge/LbPricing'
import LbSetupGuide from '../../Components/LeadBridge/LbSetupGuide'
import LbUsps from '../../Components/LeadBridge/LbUsps'
import styles from './LbHome.module.css'

const LbHome = () => {
    return (
        <div className={styles.mainWrapper} >
            <LbHero />
            <LbUsps />
            <LbHowItWorks />
            <LbSetupGuide />
            <LbAnalytics />
            <LbPricing />
            <LbFAQs />
            <LbCTA />
        </div>
    )
}

export default LbHome